'use strict';

// src/error/http-error-code.ts
var HttpErrorCode = /* @__PURE__ */ ((HttpErrorCode2) => {
  HttpErrorCode2["MISSING_PARAMS"] = "MISSING_PARAMS";
  HttpErrorCode2["NOT_FOUND"] = "NOT_FOUND";
  HttpErrorCode2["WRONG_PASSWORD"] = "WRONG_PASSWORD";
  HttpErrorCode2["FORBIDDEN"] = "FORBIDDEN";
  HttpErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  HttpErrorCode2["INVALID"] = "INVALID";
  HttpErrorCode2["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
  HttpErrorCode2["ALREADY_EXISTS"] = "ALREADY_EXISTS";
  HttpErrorCode2["UNKNOWN"] = "UNKNOWN";
  HttpErrorCode2["INVALID_CONTENT"] = "INVALID_CONTENT";
  HttpErrorCode2["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
  HttpErrorCode2["PAYMENT_FAILED"] = "PAYMENT_FAILED";
  return HttpErrorCode2;
})(HttpErrorCode || {});

// src/error/stripe-error-code.ts
var StripeErrorCode = /* @__PURE__ */ ((StripeErrorCode2) => {
  StripeErrorCode2["CARD_DECLINED"] = "card_declined";
  StripeErrorCode2["EXPIRED_CARD"] = "expired_card";
  StripeErrorCode2["INCORRECT_CVC"] = "incorrect_cvc";
  StripeErrorCode2["PROCESSING_ERROR"] = "processing_error";
  StripeErrorCode2["INCORRECT_NUMBER"] = "incorrect_number";
  return StripeErrorCode2;
})(StripeErrorCode || {});
var StripeErrorCause = /* @__PURE__ */ ((StripeErrorCause2) => {
  StripeErrorCause2["GENERIC_DECLINE"] = "generic_decline";
  StripeErrorCause2["INSUFFICIENT_FUNDS"] = "insufficient_funds";
  StripeErrorCause2["LOST_CARD"] = "lost_card";
  StripeErrorCause2["STOLEN_CARD"] = "stolen_card";
  StripeErrorCause2["CARD_VELOCITY_EXCEEDED"] = "card_velocity_exceeded";
  return StripeErrorCause2;
})(StripeErrorCause || {});

exports.HttpErrorCode = HttpErrorCode;
exports.StripeErrorCause = StripeErrorCause;
exports.StripeErrorCode = StripeErrorCode;
